import React from 'react';
import SanitizedHTML from 'react-sanitized-html';

export default function ContactSidebarText(props) {
    return (
        <SanitizedHTML html={props.text} className="module-contact-sidebar__text__text" />
    );
}